import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { signOut } from './lib/authenticationLibrary';
import { getCookie, removeCookie } from './utils/Cookies/CookieHandler';

const AuthMiddleware = ({ children }) => {
    const navigate = useNavigate();
    useEffect(() => {
        const authToken = Cookies.get('AdminAuthUser');
        const optCookie = getCookie('adminOtpValid');
        if (!optCookie?.valid) {
            removeCookie("adminOtpValid")
            window.location.href = "/login";
            return;
        }
        if (!authToken) {
            signOut()
        }
    }, [navigate]);
    return children;
};
export default AuthMiddleware;